import { render, staticRenderFns } from "./betsDialog.vue?vue&type=template&id=f1466c32&"
import script from "./betsDialog.ts?vue&type=script&lang=ts&"
export * from "./betsDialog.ts?vue&type=script&lang=ts&"
import style0 from "./betsDialog.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports